module.exports = __webpack_public_path__ + "static/media/34-8.57c89368.mp3";